import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/config-page/config-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InitCompass"] */ "/app/app/lib/init-compass.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StructuredContentWrapper"] */ "/app/app/lib/structured-content/structured-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/footer/Footer.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/header/Header.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["MyNerdWalletMenu"] */ "/app/node_modules/@nerdwallet/compass/src/header/my-nerdwallet/MyNerdWalletMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MyNerdWalletPanel"] */ "/app/node_modules/@nerdwallet/compass/src/header/my-nerdwallet/MyNerdWalletPanel.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/header/nav/L2.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/header/notifications/NotificationsButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationSidebarLoader"] */ "/app/node_modules/@nerdwallet/compass/src/header/notifications/NotificationSidebarLoader.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/header/notifications/NotificationsPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UnreadBadge"] */ "/app/node_modules/@nerdwallet/compass/src/header/notifications/UnreadBadge.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/icons/Icon.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nerdwallet/compass/src/styles/compass-tailwind.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
